// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prz-blocks{margin-top:-22px}@media screen and (min-width:1536px)and (max-width:1919px){.prz-blocks{margin-top:-32px}}@media screen and (min-width:1920px){.prz-blocks{margin-top:-42px}}", ""]);
// Exports
module.exports = exports;
